import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export type ItemMeta = SmartSendItemApiModel['Meta'];
export type OrderMeta = { reference: string; meta?: ItemMeta };

// Where an item's orders keep their meta. A grouped parcel is a new item with no meta of its own - each order's
// meta is on its marketplace orderline. A single order has it on both, so the item itself is only a fallback.
// Callers dedupe on reference, because a single order comes back twice: once from its orderline, once from the item.
export const getOrderMetas = (
  item: SmartSendItemApiModel,
  getReference: (item: SmartSendItemApiModel) => string | undefined
): OrderMeta[] => [
  ...(item.MarketplaceOrderLines ?? []).map((x) => ({
    reference: x.MarketplaceOrderId || getReference(item) || item.Id,
    meta: x.Meta
  })),
  { reference: getReference(item) || item.Id, meta: item.Meta }
];
